
import {Component, Vue} from 'vue-property-decorator';
import {itemList} from "@/api/invoice/index";
import {Decimal} from "decimal.js";

@Component({
  name: 'InvoiceItem',
})
export default class InvoiceItem extends Vue {

  public showDialog = false;
  public loading = false;
  //开票品名   数量   单位     金额  税率      税额
  public tableCol = [
    {
      label: "开票品名",
      prop: "projectName",
      key: "projectName"
    },
    {
      label: "数量",
      prop: "num",
      key: "num"
    },
    {
      label: "单位",
      prop: "unit",
      key: "unit"
    },
    {
      label: "金额",
      prop: "price",
      key: "price"
    },
    {
      label: "税率",
      prop: "taxRate",
      key: "taxRate",
      render: (prop,row)=>{
        return row.taxRate*100 + "%"
      }
    },
    {
      label: "税额",
      prop: "taxAmount",
      key: "taxAmount"
    },
    {
      label: "价税合计",
      prop: "totalAmount",
      key: "totalAmount"
    }
  ]
  private table = {
    list: [] as any[],
  };

  private getList(id) {
    itemList({id}).then(({data}) => {
      this.table.list = data as any;
      // 这里对价税合计进行计算。
      this.table.list.forEach(item => {
        item.totalAmount =  new Decimal(item.price).add(new Decimal(item.taxAmount)).toFixed(2);
      })
      this.loading = false;
    })
  }

  public async openDialog(obj) {
    this.showDialog = true;
    this.getList(obj.id)
  }
}
